export const FILTERS_ORDER_SETTINGS_KEY_VERSION_OUTPUTS = "version-outputs";
